import { render, staticRenderFns } from "./EmailLogsGrid.vue?vue&type=template&id=d12326bc"
import script from "./EmailLogsGrid.vue?vue&type=script&lang=js"
export * from "./EmailLogsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports